export function botChannelName(userId) {
  return `private-${userId}-bottle-bot`
}

export function subscribeBotChannel(pusher, userId, handler) {
  const channel = pusher.subscribe(botChannelName(userId))
  channel.bind('ai-chat-message', handler)
  return channel
}

export function unsubscribeBotChannel(pusher, userId) {
  pusher.unsubscribe(botChannelName(userId))
}
